import { render, staticRenderFns } from "./header-nomenu.vue?vue&type=template&id=efe5318a&scoped=true&keep-live=true&"
import script from "./header-nomenu.vue?vue&type=script&lang=js&"
export * from "./header-nomenu.vue?vue&type=script&lang=js&"
import style0 from "./header-nomenu.vue?vue&type=style&index=0&id=efe5318a&lang=less&scoped=true&"
import style1 from "./header-nomenu.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe5318a",
  null
  
)

export default component.exports